/**
 * Copy an arbitrary string to the user's clipboard, with a legacy fallback
 * for insecure contexts and older browsers. Returns ``true`` on success.
 *
 * Extracted from EventsShareKit so the same behaviour can be reused for
 * other "Copy" affordances on the site without duplicating the fallback
 * chain.
 */
export async function copyText(text) {
  // Modern async API — available on HTTPS + focused tabs.
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("Clipboard API failed, falling back to execCommand", err);
    }
  }
  // Legacy fallback — off-screen <textarea> + execCommand.
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return Boolean(ok);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("execCommand copy fallback failed", err);
    }
    return false;
  }
}
